<template>
  <Component class="curation-media-block" :is="rootComponent" :to="to">
    <UiCurationSpan tag="div" class="media" :id="id">
      <template #default="{ curation }" v-if="curation">
        <figure class="media-left">
          <UiImageSelection :image="curation.image" :w="48" :h="48" image-usage="thumbnail" />
        </figure>
        <div class="media-content">
          <div class="content">
            <p v-if="subtitle" class="is-size-7">{{ ls(subtitle) }}</p>
            <strong class="is-size-6-desktop is-size-7-touch">{{
              ls(curation.title)
            }}</strong>
            <p class="is-size-8 jps-line-6">{{ ls(curation.summary) }}</p>
          </div>
        </div>
      </template>
    </UiCurationSpan>
  </Component>
</template>

<script lang="ts" setup>
import { BaseLink } from '#components'

const { ls } = useI18n()

interface Props {
  curation: Curation
  page?: number
  subtitle?: LangString
  nolink?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  nolink: false,
})

const rootComponent = computed(() => {
  if (props.nolink) {
    return 'span'
  } else {
    return BaseLink
  }
})

const id = computed(() => {
  if (props.page != null) {
    return props.curation.subPages[props.page - 1]
  } else {
    return props.curation.id
  }
})

const to = computed(() => {
  if (props.page != null) {
    return `/gallery/${props.curation.id}/${props.page}`
  } else {
    return `/gallery/${props.curation.id}`
  }
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-media-block {
  display: block;
  padding: 0.75rem;
  &.router-link-exact-active {
    background-color: $jps-gray-100 !important;
  }
  .media-content {
    strong {
      display: block;
      margin-bottom: 0.25rem;
    }
  }
}
</style>
